import { createSelector } from '@reduxjs/toolkit'
import type { ListType } from './reducers'

/**
 * Selector to get reasons for a specific option
 * This is memoized to prevent unnecessary re-renders
 */
export const makeSelectReasonsByOptionId = () =>
  createSelector(
    [
      (state: ListType) => state.reasons,
      (_state: ListType, optionId: string) => optionId,
    ],
    (reasons, optionId) =>
      reasons.filter((reason) => reason.optionId === optionId),
  )

/**
 * Selector to check if an option has AI-generated reasons
 */
export const makeSelectHasAiGeneratedReasons = () =>
  createSelector([makeSelectReasonsByOptionId()], (reasons) =>
    reasons.some((reason) => reason.aiGenerated),
  )
